import { CommunityPostGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ReactElement } from "react";
import { TimeZone } from "client/DateAndTime/timezones";
import { CommunityPostListItem } from "../../../Items/CommunityPostListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useCommunityPostNavigationHandler } from "../../../Navigation/useCommunityPostNavigationHandler";

export type CommunityPostItemViewProps = {
	item: CommunityPostGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const CommunityPostItemView = (props: CommunityPostItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const {
		id,
		community,
		createdBy,
		messagePreview,
		hitHighlights,
		createdOn
	} = item;

	const openHandler: () => void = useCommunityPostNavigationHandler({
		id,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("community-post-item", `|${id}`)}
			onClick={openHandler}
		>
			<CommunityPostListItem
				id={id}
				communityName={community.name}
				createdBy={createdBy}
				createdOn={createdOn}
				messagePreview={messagePreview}
				hitHighlights={hitHighlights}
				timezone={timezone}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
CommunityPostItemView.displayName = "CommunityPostItemView";
